import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCapacityRoute: InvariantJiraRoute = {
	name: 'classic-business-capacity',
	exact: true,
	path: '/jira/core/projects/:projectKey/capacity/:view(people|work)?',
};
